export interface ChatProps {
    description: string | null;
    followers: number;
    id: number;
    image: string;
    title: string;
    type: ChatType;
    updated_at: Date;
    created_at: Date;

    knowledge: [];
    rules: [];
    tags: ChatTagProps[];
}

export const CHAT_TYPE = {
    GROUP: 'group',
    SUPERGROUP: 'supergroup',
    CHANNEL: 'channel',
} as const;

export type ChatType = (typeof CHAT_TYPE)[keyof typeof CHAT_TYPE];
export interface ChatFilters {
    name: string;
    tag_names: string[];
    date_from: string | null;
    date_to: string | null;

    limit: number;
    offset: number;
    page: number;

    rules_uuids?: string[];
    is_chat_bot_source?: boolean;
    is_user_bot_source?: boolean;
}

export interface ChatTagProps {
    id: number;
    name: string;
    user_id: number;
}

export const COMMUNITY_TYPE = {
    MANAGE: 'manage',
    MONITORING: 'monitoring',
} as const;

export type CommunityType =
    (typeof COMMUNITY_TYPE)[keyof typeof COMMUNITY_TYPE];
